import { lazy } from 'react';

export const ClassList = lazy(() => import('./ClassList'));
